import React, { useState, useEffect } from "react";
import PCS from "./PCS";
import { useParams } from "react-router-dom";
import "./EstilosEsquema.css";

function Circuito(props) {
    const params = useParams();
    const { ct } = params;
    const idParque = JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm;
    const { code } = props;
    const variablesAPedir = "idInverter,name,status,statusLevel,color";
    const [pcs, setPcs] = useState({
        id: "pcs-1",
        inverters: [],
        switches: {
            left: { id: "left-switch", name: "LV Breaker A", state: true },
            right: { id: "right-switch", name: "LV Breaker B", state: true }
        }
    });

    // Realiza la consulta a la API cuando el componente se monta
    useEffect(() => {
        const fetchInverters = async () => {
            try {
                const response = await fetch(
                    `${window.location.protocol}//${window.location.hostname}/api/lastData/inverters?idSolarFarm=${idParque}&idCT=${ct}&variables=${variablesAPedir}`,
                    { method: "GET", credentials: "include" }
                );
                const data = await response.json();

                //Extraer los campos requeridos
                const inverters = data.map((inv) => ({
                    idInverter: inv.idInverter,
                    name: inv.name,
                    status: inv.status,
                    statusLevel: inv.statusLevel,
                    color: inv.color
                }));

                // Actualizar el estado con los inverters obtenidos
                setPcs((prevState) => ({
                    ...prevState,
                    inverters: inverters
                }));
            } catch (error) {
                console.error("Error fetching inverters:", error);
            }
        };

        fetchInverters();

        // Hacer la consulta cada 30 segundos
        const interval1 = setInterval(() => {
            if (code === sessionStorage.getItem("key")) { // Verifica si no ha cambiado de página
                fetchInverters();
            } else { // Si ha cambiado de página, cancela el intervalo
                clearInterval(interval1);
            }
        }, 30000);

        // Limpiar el intervalo cuando el componente se desmonte
        return () => clearInterval(interval1);
    }, [ct, code, idParque, variablesAPedir]);

    const toggleInverter = (invId) => {
        setPcs((prevState) => ({
            ...prevState,
            inverters: prevState.inverters.map((inv) => {
                if (inv.idInverter === invId) {
                    let newStatusLevel = inv.statusLevel;
                    if (inv.statusLevel === "0") {
                        newStatusLevel = "1"; // Si está en 0, pasa a 1
                    } else if (inv.statusLevel === "1" || inv.statusLevel === "2") {
                        newStatusLevel = "0"; // Si está en 1 o 2, pasa a 0
                    }
                    return { ...inv, statusLevel: newStatusLevel }; // Actualizamos el statusLevel
                }
                return inv;
            }),
        }));
    };

    const toggleSwitch = (side) => {
        setPcs((prevState) => ({
            ...prevState,
            switches: {
                ...prevState.switches,
                [side]: {
                    ...prevState.switches[side],
                    state: !prevState.switches[side].state
                }
            }
        }));
    };

    return (
        <div>
            <PCS {...pcs} toggleInverter={toggleInverter} toggleSwitch={toggleSwitch} />
        </div>
    );
}

export default Circuito;
